/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex, Menu, MenuList, Spinner, Table, TableContainer, Tbody, Text, Thead, useToast } from '@chakra-ui/react'
import { PDFDownloadLink } from '@react-pdf/renderer'
import 'pdfjs-dist/build/pdf.worker.entry'
import React, { useEffect, useState } from 'react'
import { BsCoin } from 'react-icons/bs'
import { FaChevronDown, FaDownload, FaFilePdf } from 'react-icons/fa'
import { FaPeopleGroup } from 'react-icons/fa6'
import { MdOutlineBusinessCenter } from 'react-icons/md'
import { pdfjs } from 'react-pdf'
import { useNavigate } from 'react-router-dom'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import LoadingContainer from '../../../../components/LoadingContainer'
import { MenuButtonCmp } from '../../../../components/MenuButtonCmp'
import { ModalDelete } from '../../../../components/ModalDelete'
import { StyledMenuItem } from '../../../../components/NavBar/Components/StyledMenuItem'
import { SearchCmp } from '../../../../components/SearchCmp'
import { appApi } from '../../../../services/appApi'
import { parseJwt } from '../../../../services/token'
import { Body } from '../../../Layouts/Body'
import { formatarData } from '../../components/TabelaPerfis'
import { BoxQtd } from './components/BoxQtd'
import { ModalProgresso } from './components/ModalProgresso'
import { ModalTabelaAderencia } from './components/ModalTabelaAderencia'
import { PieChart } from './components/PieChart'
import { RelatorioIndividualPDF } from './components/RelatorioIndividualPDF'
import { RelatorioPDF } from './components/RelatorioPDF'
import { iRelatorioIndividualSI, iRelatorioSI } from './interfaceRelatorioSI'
import { StyledSpan, Td, Th, Tr } from './styles'

export interface itemGestao {
  id: string
  nome: string
  cpf: string
  email: string
  assessmentId: string
  linkedin: string
  gestor: string
  emailGestor: string
  nomeBP: string
  nomeCargo: string
  assessmentIdGestor: string
  urlRelatorioCandidato: string
  urlpiCandidato: string
  urlpiGestor: string
  urlCurriculo: string
  urlRelatorioGestor: string
  urlDescritivoCargo: string
  urlpiDesenvolvimento?: string
  dataCriacao?: string
  dataAlterado?: string
  urlpiRelacionamentoGestor?: string
  dadosGpt?: string
  status: number
  urlpdfRelatorioRH?: string
  urlpdfRelatorioIndividual?: string
}

interface iDash {
  top10: iTop10[]
  nomeCargoUnicos: number
  totalRegistros: number
  tipoAcesso: number
  creditos: number
  aderentes: itemGestao[]
  aderentesResalva: itemGestao[]
  naoAderentes: itemGestao[]
  statusAssessments: statusDash[]
}

interface statusDash {
  id: number
  quantidade: number
}

export interface iTop10 {
  nomeBp: string
  quantidade: number
}

export const DashboardSI: React.FC = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const toast = useToast()
  const nav = useNavigate()
  const [Dash, setDash] = useState<iDash>({ nomeCargoUnicos: 0, top10: [], totalRegistros: 0, statusAssessments: [], creditos: 0, tipoAcesso: 0, aderentes: [], aderentesResalva: [], naoAderentes: [] })
  const [IsLoading, setIsLoading] = useState<string>()
  const [ModalProgressoIsOpen, setModalProgressoIsOpen] = useState(false)
  const [Model, setModel] = useState<iRelatorioSI>()
  const [ModelIndividual, setModelIndividual] = useState<iRelatorioIndividualSI>()
  const [BaixarRelatorio, SetBaixarRelatorio] = useState(false)
  const [BaixarRelatorioIndividual, SetBaixarRelatorioIndividual] = useState(false)
  const [ItemAtivo, setItemAtivo] = useState<string>()
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [ModalAderenciaIsOpen, setModalAderenciaIsOpen] = useState(false)
  const [Candidatos, setCandidatos] = useState<itemGestao[]>([])
  const [Titulo, setTitulo] = useState('')
  const token = parseJwt()
  function onGetModelRelatorio(id: string): void {
    setIsLoading(id)
    appApi.get(`api/SI/Relatorio/${id}`)
      .then((res) => setModel(res.data))
      .catch((err) => console.log(err))
  }

  function onChangeStatus(id: string, status: string): void {
    setIsLoadingBody(true)
    appApi.put(`api/SI/${id}/trocarStatus?statusNovo=${status}`)
      .then((res) => GetItems())
      .catch((err) => { console.log(err); setIsLoadingBody(false) })
  }

  function onGetModelIndividual(id: string): void {
    setIsLoading(id)
    appApi.get(`api/SI/Relatorio/${id}/Individual`)
      .then((res) => setModelIndividual(res.data))
      .catch((err) => console.log(err))
  }

  function OnOpenModal(titulo: string): void {
    setIsLoadingBody(true)
    setTimeout(() => {
      setModalAderenciaIsOpen(true)
      setTitulo(titulo)
      setIsLoadingBody(false)
    }, 300)
  }

  function onGetDash(): void {
    setIsLoadingBody(true)
    appApi.get('api/SI/Dashboard')
      .then((res) => setDash(res.data))
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          setIsLoadingBody(false)
        }, 400)
      })
  }

  const baixarRelatorio = async (model: itemGestao, linkUrl: string, posNomeArquivo: string) => {
    const response = await fetch(linkUrl)
    const blob = await response.blob()
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = `${model.nome.replaceAll(' ', '_')}_${posNomeArquivo}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  function onPostRelatorio(base64: string, isIndividual: boolean, segundoRelatorio: boolean): void {
    appApi.post(`api/SI/${ItemAtivo}/uploadRelatorioPDF`, { pdf: base64, individual: isIndividual })
      .then(() => {
        if (segundoRelatorio) {
          GetItems(undefined, true)
          setIsLoading(undefined)
          setItemAtivo(undefined)
          SetBaixarRelatorioIndividual(false)
          SetBaixarRelatorio(false)
          setModalProgressoIsOpen(false)
        } else {
          SetBaixarRelatorio(true)
        }
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    if (BaixarRelatorio) {
      setTimeout(async () => {
        const botao: any = document.getElementById('botaoBaixarRelatorio')
        const response = await fetch(botao.href)
        const blob = await response.blob()
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => {
          const base64PDF = reader.result as string
          if (base64PDF.includes('html;base64')) {
            SetBaixarRelatorio(false)
            setTimeout(() => {
              SetBaixarRelatorio(true)
            }, 300)
          } else {
            onPostRelatorio(base64PDF, false, true)
          }
        }
        SetBaixarRelatorio(false)
      }, 3500)
    }
  }, [BaixarRelatorio])

  useEffect(() => {
    if (BaixarRelatorioIndividual) {
      setTimeout(async () => {
        const botao: any = document.getElementById('botaoBaixarRelatorioIndividual')
        const response = await fetch(botao.href)
        const blob = await response.blob()
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onloadend = () => {
          const base64PDF = reader.result as string
          if (base64PDF.includes('html;base64')) {
            SetBaixarRelatorioIndividual(false)
            setTimeout(() => {
              SetBaixarRelatorioIndividual(true)
            }, 300)
          } else {
            onPostRelatorio(base64PDF, true, false)
          }
        }
      }, 500)
    }
  }, [BaixarRelatorioIndividual])

  function OnClearRelatorios(): void {
    setModel(undefined)
    setModelIndividual(undefined)
    setItemAtivo(undefined)
    setModalProgressoIsOpen(false)
  }

  const [IsLoadingBody, setIsLoadingBody] = useState(false)
  const [SearchText, setSearchText] = useState('')
  const [Items, setItems] = useState<itemGestao[]>([])
  const tokenJwt = localStorage.getItem('token')
  function GetPermissaoBotoesClaro(): boolean {
    return Dash.tipoAcesso === 1 || Dash.tipoAcesso === 2
  }

  function GetItems(firstReq?: boolean, isRelatorio?: boolean): void {
    if (firstReq) setIsLoadingBody(true)
    appApi.get('api/SI')
      .then((res) => {
        setItems(res.data)
        if (isRelatorio) {
          toast({
            title: 'Relatórios gerados com sucesso!',
            status: 'success',
            duration: 4000,
            position: 'top'
          })
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoadingBody(false))
  }

  function DeleteItem(id: string): void {
    setIsLoadingBody(true)
    appApi.delete(`api/SI/${id}`)
      .then((res) => GetItems())
      .catch((err) => { console.log(err); setIsLoadingBody(false) })
  }

  function GetStatus(status: number): any {
    const color = status === 9 ? 'var(--Red)' : (status === 3 || status === 4) ? 'var(--Green2)' : status === 0 ? 'var(--Gray2)' : 'var(--Orange)'
    let text: any
    switch (status) {
      case 0:
        text = 'Novo'
        break
      case 1:
        text = 'Aguardando processamento'
        break
      case 2:
        text = 'Processando'
        break
      case 3:
        text = 'Concluído e oculto'
        break
      case 4:
        text = 'Concluído e liberado'
        break
      case 5:
        text = 'Processando linkedin'
        break
      case 6:
        text = 'Aguardando linkedin'
        break
      case 7:
        text = 'Aguardando PI do candidato'
        break
      case 8:
        text = 'Aguardando PI do gestor'
        break
      case 9:
        text = 'Erro'
        break
      case 10:
        text = 'Aguardando revisão'
        break
      case 11:
        text = 'Aguardando relacionamento'
        break
      case 12:
        text = 'Processando relacionamento'
        break
      case 13:
        text = 'Nova solicitação'
        break
    }

    return <Flex as='strong' color={color} fontWeight={600}>{text}</Flex>
  }

  function GetStatusTitulo(status: number): string {
    let text: any
    switch (status) {
      case 0:
        text = 'Novo'
        break
      case 1:
        text = 'Aguardando processamento'
        break
      case 2:
        text = 'Processando'
        break
      case 3:
        text = 'Concluído e oculto'
        break
      case 4:
        text = 'Concluído e liberado'
        break
      case 5:
        text = 'Processando linkedin'
        break
      case 6:
        text = 'Aguardando linkedin'
        break
      case 7:
        text = 'Aguardando PI do candidato'
        break
      case 8:
        text = 'Aguardando PI do gestor'
        break
      case 9:
        text = 'Erro'
        break
      case 10:
        text = 'Aguardando revisão'
        break
      case 11:
        text = 'Aguardando relacionamento'
        break
      case 12:
        text = 'Processando relacionamento'
        break
      default:
        text = ''
    }

    return text
  }

  function OnGerarRelatorios(id: string): void {
    setItemAtivo(id)
    onGetModelIndividual(id)
    onGetModelRelatorio(id)
  }

  useEffect(() => {
    if (ItemAtivo && IsLoading && ItemAtivo === IsLoading) {
      setModalProgressoIsOpen(true)
      SetBaixarRelatorioIndividual(true)
    }
  }, [Model, ModelIndividual])

  useEffect(() => {
    GetItems(true)
    onGetDash()
  }, [])

  return (
    <Body isLoading={IsLoadingBody}>
      {ModalAderenciaIsOpen && <ModalTabelaAderencia
        IsLoading={IsLoading}
        baixarRelatorio={baixarRelatorio}
        candidatos={Candidatos}
        isOpen={ModalAderenciaIsOpen}
        onChangeStatus={onChangeStatus}
        onRequestClose={() => {
          setModalAderenciaIsOpen(false)
          setCandidatos([])
        }}
        tipoAcesso={Dash.tipoAcesso}
        titulo={Titulo}
      />}
      {ItemAtivo && <ModalDelete
        isOpen={ModalDeleteIsOpen}
        message='Tem certeza que deseja excluir esse item?'
        onConfirm={() => DeleteItem(ItemAtivo)}
        center
        onRequestClose={() => { setModalDeleteIsOpen(false); setItemAtivo(undefined) }}
      />}
      <ModalProgresso
        isOpen={ModalProgressoIsOpen}
        onRequestClose={() => setModalProgressoIsOpen(false)}
      />
      {BaixarRelatorio && Model && <PDFDownloadLink
        document={
          <RelatorioPDF
            model={Model}
          />
        }
        id='botaoBaixarRelatorio'
      >
        {() =>
          <Box pos={'absolute'}></Box>
        }
      </PDFDownloadLink>}
      {BaixarRelatorioIndividual && ModelIndividual && <PDFDownloadLink
        document={
          <RelatorioIndividualPDF
            model={ModelIndividual}
          />
        }
        id='botaoBaixarRelatorioIndividual'
      >
        {() =>
          <Box pos={'absolute'}></Box>
        }
      </PDFDownloadLink>}
      <Flex gap={'1.75rem'}>
        <Flex flexDir={'column'} gap={'1.75rem'} w={'100%'}>
          <Flex gap={'1rem'}>
            <BoxQtd
              titulo='Número de relatórios'
              icon={<FaPeopleGroup size={30}/>}
              quantidade={Dash.totalRegistros}
            />
            <BoxQtd
              titulo='Número de relatórios disponíveis'
              icon={<BsCoin size={30}/>}
              quantidade={Dash.creditos}
            />
            <BoxQtd
              titulo='Número de cargos'
              icon={<MdOutlineBusinessCenter size={30}/>}
              quantidade={Dash.nomeCargoUnicos}
            />
          </Flex>
          {(Dash.aderentes.length > 0 || Dash.aderentesResalva.length > 0 || Dash.naoAderentes.length > 0) && <Flex border={'1px solid var(--c6)'} alignItems={'center'} justifyContent={'center'} h={'15rem'} width={'100%'} boxShadow={'var(--SombraBackground)'} bg={'var(--c1)'} px={'1rem'} borderRadius={'.325rem'} gap={'.5rem'}>
            <Flex flexDir={'column'} gap={'.325rem'}>
              <Flex gap={'.325rem'} fontSize={'.875rem'} alignItems={'center'}>
                <Flex borderRadius={'50%'} w={'.875rem'} h={'.875rem'} bg={'var(--Green2)'}></Flex>
                Aderentes
              </Flex>
              <Flex gap={'.325rem'} fontSize={'.875rem'} alignItems={'center'}>
                <Flex borderRadius={'50%'} w={'.875rem'} h={'.875rem'} bg={'var(--Yellow)'}></Flex>
                Aderentes com ressalvas
              </Flex>
              <Flex gap={'.325rem'} fontSize={'.875rem'} alignItems={'center'}>
                <Flex borderRadius={'50%'} w={'.875rem'} h={'.875rem'} bg={'var(--Red)'}></Flex>
                Não aderentes
              </Flex>
            </Flex>
            <PieChart aderentes={Dash.aderentes.length} aderentesResalva={Dash.aderentesResalva.length} naoAderentes={Dash.naoAderentes.length} id={'pie-chart-aderentes-e-nao-aderentes-id'} onChoiceAderencia={(tipoAderencia) => {
              OnOpenModal(tipoAderencia === 0 ? 'Aderentes' : tipoAderencia === 1 ? 'Aderentes com ressalvas' : 'Não aderentes')
              setCandidatos(tipoAderencia === 0 ? Dash.aderentes : tipoAderencia === 1 ? Dash.aderentesResalva : Dash.naoAderentes)
            }}/>
          </Flex>}
        </Flex>
        <BoxQtd
          titulo='Business partners com mais vagas'
          tabela={Dash.top10}
          onClick={(nomeBp) => { setCandidatos(Items.filter(it => it.nomeBP === nomeBp)); OnOpenModal('BP: ' + nomeBp) }}
        />
      </Flex>
      <Flex gap={'1rem'} mt={'1.5rem'}>
        {Dash.statusAssessments.filter(e => e.id === 1 || e.id === 2 || e.id === 3 || e.id === 4 || e.id === 9).map(e => {
          return <BoxQtd titulo={GetStatus(e.id)} quantidade={e.quantidade} onClick={() => { setCandidatos(Items.filter(it => it.status === e.id)); OnOpenModal(GetStatusTitulo(e.id)) }} color={'black'} small/>
        })}
      </Flex>
      <Flex justifyContent={'space-between'} margin='1.75rem 0rem'>
        <Flex flexDir={'column'}>
          <h1>Gestão de relatórios PRISMAH</h1>
        </Flex>
        <Flex gap={'.5rem'} justifyContent={'end'}>
          <ButtonCmp
          VarColor='Rosa'
          onClick={() => { window.location.href = `${process.env.REACT_APP_URL_API}/api/SI/relatorioCSV/${tokenJwt}` }}>Relatório
          </ButtonCmp>
          <SearchCmp
            EnterAction={() => { }}
            OnChange={setSearchText}
            placeholder={'Buscar'}
          />
        </Flex>
      </Flex>

      <LoadingContainer linhas={18} loading={IsLoadingBody}>
          {Items?.length > 0 && <TableContainer overflowX={'hidden'}>
            <Table variant='simple' border={'1px solid var(--c5)'}>
              <Thead>
                <Tr>
                  <Th style={{ textAlign: 'left', paddingLeft: '1.5rem' }}>Candidato</Th>
                  <Th>Gestor</Th>
                  <Th>Vaga</Th>
                  <Th>Nome do BP</Th>
                  <Th>Informações</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {Items?.filter(e => {
                  if (SearchText === '') {
                    return e
                  } else if (e.nome.toLowerCase().includes(SearchText.toLowerCase()) || e.nomeBP.toLowerCase().includes(SearchText.toLowerCase()) || e.gestor.toLowerCase().includes(SearchText.toLowerCase()) || e.email.toLowerCase().includes(SearchText.toLowerCase()) || e.emailGestor.toLowerCase().includes(SearchText.toLowerCase()) || GetStatusTitulo(e.status).toLowerCase().includes(SearchText.toLowerCase()) || e.nomeCargo.toLowerCase().includes(SearchText.toLowerCase())) {
                    return e
                  }

                  return null
                })?.map(e => {
                  return (
                    <Tr key={e.id}>
                      <Td style={{ textAlign: 'left', paddingLeft: '1.5rem', minWidth: '17rem' }}>
                        <Flex flexDir={'column'} lineHeight={'12px'}>
                          <StyledSpan style={{ justifyContent: 'start' }}>
                            <Text color={'Gray1'} fontSize={'12px'} fontWeight={'600'}>{e.nome}</Text>
                          </StyledSpan>
                          <StyledSpan style={{ justifyContent: 'start', maxWidth: '17rem' }}>
                            <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>{e.email}</Text>
                          </StyledSpan>
                        </Flex>
                      </Td>
                      <Td>
                        <StyledSpan style={{ maxWidth: '7rem', minWidth: '7rem' }}>
                          <Text className='textWrap' color={'Gray1'} maxW={'7rem'} wordBreak={'break-word'} fontSize={'12px'} fontWeight={'400'} textAlign={'center'}>{e.gestor}</Text>
                        </StyledSpan>
                      </Td>
                      <Td>
                        <StyledSpan>
                          <Text color={'Gray1'} wordBreak={'break-word'} fontSize={'12px'} fontWeight={'400'} textAlign={'center'} className='textWrap' maxW={'9rem'} minW={'9rem'}>{e.nomeCargo}</Text>
                        </StyledSpan>
                      </Td>
                      <Td>
                        <StyledSpan>
                          <Text color={'Gray1'} wordBreak={'break-word'} fontSize={'12px'} fontWeight={'400'} textAlign={'center'} className='textWrap' maxW={'9rem'} minW={'9rem'}>{e.nomeBP}</Text>
                        </StyledSpan>
                      </Td>
                      <Td>
                        <Flex flexDir={'column'} gap={'.125rem'} lineHeight={'14px'} maxW={'12rem'}>
                          <StyledSpan>
                            <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>Data de criação: <strong>{formatarData(e.dataCriacao ?? '')}</strong></Text>
                          </StyledSpan>
                          <StyledSpan>
                            <Text color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>Data de alteração: <strong>{e.dataAlterado ? formatarData(e.dataAlterado) : '-'}</strong></Text>
                          </StyledSpan>
                          <StyledSpan>
                            <Text display={'flex'} gap={'.25rem'} color={'Gray1'} fontSize={'12px'} fontWeight={'400'}>Status: {GetStatus(e.status)}</Text>
                          </StyledSpan>
                        </Flex>
                      </Td>
                      <Td>
                        <StyledSpan style={{ gap: '.75rem' }}>
                          <Flex flexDir={'column'} gap={'.625rem'} alignItems='center' justifyContent={'center'} w={'full'}>
                            {(e.status !== 1 && e.status !== 2) && (Dash.tipoAcesso === 1 || e.status !== 10) && (GetPermissaoBotoesClaro() || (e.status === 4)) && <Menu>
                              <MenuButtonCmp
                                    Icon={<FaChevronDown size={8} style={{ marginLeft: '-4px' }}/>}
                                    VarColor='Green2'
                                    width='8rem'
                                    small
                                >Opções
                              </MenuButtonCmp>
                                <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'} border={'1px solid var(--c5)'}>
                                  {Dash.tipoAcesso === 1 && e.status === 13 && <StyledMenuItem onClick={() => nav(`/PRISMAH/${e.id}/SelecionarPI`)}>
                                    Selecionar PI
                                  </StyledMenuItem>}
                                  {Dash.tipoAcesso === 1 && e.status !== 13 && <StyledMenuItem onClick={() => nav(`/PRISMAH/${e.id}/Editar`)}>
                                    Editar relatório
                                  </StyledMenuItem>}
                                  {e.status !== 10 && GetPermissaoBotoesClaro() && <StyledMenuItem onClick={() => onChangeStatus(e.id, '3')}>
                                    Ocultar relatório
                                  </StyledMenuItem>}
                                  {e.status !== 10 && (e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH) && (GetPermissaoBotoesClaro()) && <StyledMenuItem onClick={() => onChangeStatus(e.id, '4')}>
                                    Liberar relatório
                                  </StyledMenuItem>}
                                  {e.status === 10 && Dash.tipoAcesso === 1 && <StyledMenuItem onClick={() => onChangeStatus(e.id, '3')}>
                                    Liberar para o RH
                                  </StyledMenuItem>}
                                  {e.status !== 10 && Dash.tipoAcesso === 1 && <StyledMenuItem onClick={() => onChangeStatus(e.id, '10')}>
                                    Ocultar para o RH
                                  </StyledMenuItem>}
                                  <StyledMenuItem onClick={() => { window.location.href = `${process.env.REACT_APP_URL_API}/api/SI/ExportarDadosCSV/${e.id}` }}>
                                    Baixar recomendações (CSV)
                                  </StyledMenuItem>
                                  {e.urlDescritivoCargo && <StyledMenuItem onClick={() => { window.location.href = e.urlDescritivoCargo }}>
                                    Baixar descritivo de cargo
                                  </StyledMenuItem>}
                                  {e.urlCurriculo && <StyledMenuItem onClick={() => { window.location.href = e.urlCurriculo }}>
                                    Baixar currículo
                                  </StyledMenuItem>}
                                  {e.urlpiCandidato && <StyledMenuItem onClick={() => { window.location.href = e.urlpiCandidato }}>
                                    Baixar PI do candidato
                                  </StyledMenuItem>}
                                  {e.urlpiDesenvolvimento && <StyledMenuItem onClick={() => { window.location.href = e.urlpiDesenvolvimento ?? '' }}>
                                    Baixar PI - Quadro de desenvolvimento
                                  </StyledMenuItem>}
                                  {e.urlpiGestor && <StyledMenuItem onClick={() => { window.location.href = e.urlpiGestor ?? '' }}>
                                    Baixar PI do gestor
                                  </StyledMenuItem>}
                                  {e.urlpiRelacionamentoGestor && <StyledMenuItem onClick={() => { window.location.href = e.urlpiRelacionamentoGestor ?? '' }}>
                                    Baixar PI - Relacionamento com gestor
                                  </StyledMenuItem>}
                                  {Dash.tipoAcesso === 1 && <StyledMenuItem onClick={() => { setItemAtivo(e.id); setModalDeleteIsOpen(true) }}>
                                    Excluir item
                                  </StyledMenuItem>}
                                </MenuList>
                            </Menu>}
                            {(Dash.tipoAcesso === 1 || e.status !== 10) && e.status !== 13 && (e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH) && <Menu onClose={() => {
                              setTimeout(() => {
                                OnClearRelatorios()
                              }, 2000)
                            }}>
                              <MenuButtonCmp
                                    LeftIcon={<FaFilePdf size={12} style={{ marginLeft: '-4px' }}/>}
                                    VarColor='Rosa'
                                    width='8rem'
                                    small
                                >Relatórios
                              </MenuButtonCmp>
                              {IsLoading !== e.id && <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'} border={'1px solid var(--c5)'}>
                                {<StyledMenuItem onClick={() => {
                                  baixarRelatorio(e, e.urlpdfRelatorioRH ?? '', 'Assessment')
                                }}>
                                  <FaDownload style={{ marginRight: '.375rem' }} size={'14'}/>
                                  Relatório para o RH
                                </StyledMenuItem>}
                                {<StyledMenuItem onClick={() => {
                                  baixarRelatorio(e, e.urlpdfRelatorioRH ?? '', 'Assessment')
                                }}>
                                  <FaDownload style={{ marginRight: '.375rem' }} size={'14'}/>
                                  Relatório para o Gestor
                                </StyledMenuItem>}
                                {<StyledMenuItem onClick={() => {
                                  baixarRelatorio(e, e.urlpdfRelatorioIndividual ?? '', 'Individual')
                                }}>
                                  <FaDownload style={{ marginRight: '.375rem' }} size={'14'}/>
                                  Relatório individual
                                </StyledMenuItem>}
                              </MenuList>}
                              {IsLoading === e.id && <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'} border={'1px solid var(--c5)'}>
                                <StyledMenuItem>
                                    <Spinner size={'sm'} mr={'.625rem'}/>
                                    Carregando relatórios...
                                  </StyledMenuItem>
                              </MenuList>}
                            </Menu>}
                            {(Dash.tipoAcesso === 1 || e.status !== 10) && e.status !== 13 && !(e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH) && (((e.status === 3 || e.status === 10) && (token.adm === 'True' || token.cid === 'a5ee6794-41de-4163-983b-b3e66912b72e')) || (e.status === 4)) && <ButtonCmp h={'24px'} width='8rem' fontSize={'12px'} isLoading={IsLoading === e.id} VarColor='Roxo' onClick={() => OnGerarRelatorios(e.id)}>Gerar relatórios</ButtonCmp>}
                          </Flex>
                        </StyledSpan>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
          </TableContainer>}
      </LoadingContainer>

      {
        (Items?.length === 0 && !IsLoadingBody) && (
          <Flex py={'1rem'}>Não foram encontrados nenhum Assessment com estes parâmetros de busca</Flex>
        )
      }
    </Body>
  )
}
